import { createBrowserHistory } from 'history';

let _history;
const history = ()=>{
    if (!_history) {
        _history = createBrowserHistory();
    }
    return _history;
};

export { history };
//# sourceMappingURL=history.js.map
